import * as React from "react";

import "./manage-headshots-route.scss";

import {cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Types}          from "@Common/types";

import {AccountHeadshotsPanel} from "../account/common/headshots-panel/headshots-panel";
import {EmulationModal}        from "../common/emulation-modal/emulation-modal";
import {SubHeader}             from "../common/sub-header/sub-header";
import {Layout}                from "../layout/layout";

export const ManageHeadshotsRoute = () => cst<{
    emulationModal : Types.Xpresso.Common.EmulationModal.EmulationModalNext,
    session        : Types.Xpresso.Loaders.ContextNameMap['session'],
    routerHistory  : Types.Xpresso.Loaders.ContextNameMap['routerHistory'],
}>(
    cstAssign("emulationModal", ({}, next) => EmulationModal({next})),
    consumeContext("session"),
    consumeContext("routerHistory"),
    ({emulationModal, session, routerHistory}) => (<Layout active="manage-headshots">
        <SubHeader
            backLink={
                <a
                    onClick={() => routerHistory.goBack()}
                    className="back"
                    xd-qa-type="link"
                    xd-qa-name="Back"
                >
                    <i className="fa fa-chevron-left"/> Back
                </a>
            }
            title="Manage Headshots"
        />

        <div className="manage-headshots-12tf">
            {session.value?.agentId && session.emulated && (
                <div className="ui"><a onClick={() => emulationModal.show()}>Change User</a></div>
            )}
            {AccountHeadshotsPanel({})}
        </div>
    </Layout>),
);
